<template>
	<div>
        <tbody>
			<template>
				<div class="Rectangle-12-Copy-2">
                    <slot name="ODrows" v-for="row in rows" :row="row"></slot>
				</div>
			</template>
		</tbody>
	</div>
</template>

<script>
export default {
	name: 'app-table-disenar-escala-Odata',
	props: {
		// puesto: String,
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
    tbody {
        margin: 0 auto;
        display: block;
    }
    .Rectangle-12-Copy-2 {
        width: 100%;
        max-width: 1032px;
        height: 44px;
        margin: 6px auto 85px;
        padding: 6px 10px 5px 35px;
        border-radius: 9px;
        border: solid 1px #e9e9e9;
        background-color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .Orange-Data-elemento {
        width: 350px;
        height: 26px;
        font-family: NeuzeitGroT;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: normal;
        text-align: center;
        color: #545a54;
        display: block;
    }
    .Orange-Data-elemento:nth-child(1) {
        text-align: left;
        padding-left: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/table-disenar-escala/app-table-disenar-escala-Odata.vue